<script>
import { formatTenThousand, formatASCII } from 'common/js/format'
import {
  insTypeName,
  insTypeOrders,
  // normalizeKeys
} from 'base/config'
import Insurance from 'base/model/insurance'
import { stuffingTemplateIns } from 'components/liability/common'

export default {
  name: 'LiabilityPbTable',
  components: {},
  filters: {},
  mixins: [],
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    pbResultData: {
      type: Object,
      default() {
        return {}
      },
    },
    showType: {
      type: Number,
      default: 0,
    },
    showComplete: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    applicantLen() {
      const { pbResultData } = this
      if (!pbResultData || !Array.isArray(pbResultData.liabilities)) return 0
      let count = 0
      pbResultData.liabilities.forEach((item) => {
        const insLibs = item.insuranceLiabilities
        if (!Array.isArray(insLibs)) return
        count += insLibs.length
      })
      return count
    },
    applicantInfo() {
      const { pbResultData } = this
      if (
        !pbResultData ||
        !pbResultData.resultData ||
        !pbResultData.resultData.personData ||
        !Array.isArray(pbResultData.resultData.personData.personOrderList)
      )
        return {}
      return pbResultData.resultData.personData.personOrderList.filter(
        (item) => {
          return item.key === 'applicantInfo'
        }
      )[0]
    },
    arrangeInInsType() {
      const { pbResultData } = this
      let temp = pbResultData.liabilities
      if (!pbResultData || !temp) return {}
      // let accountMap = pbResultData.accountMap
      // let arrangeInIns = []
      let arrangeInInsType = []
      let accidentInIns = []
      let categorySort =
        (pbResultData.resultData && pbResultData.resultData.categorySort) ||
        'normal'
      let insTypeOrder = insTypeOrders[categorySort] || insTypeOrders.normal
      // let diseasesPath = []

      for (let pidx = 0, plen = temp.length; pidx < plen; pidx++) {
        let product = temp[pidx] // 产品
        let productId = product.productId
        let insurance = product.insuranceLiabilities
        let insuranceLen = insurance && insurance.length
        // let arrangeProduct = []
        let accProduct = []

        let accInsurance = product.accidentLiabilities
        let accInsuranceLen = accInsurance && accInsurance.length

        if (!insuranceLen && !accInsuranceLen) continue
        for (let idx = 0; idx < insuranceLen; idx++) {
          let ins = insurance[idx] // 险种
          let insId = ins.insuranceId // 险种id
          let insName = ins.insuranceName // 险种名字
          let liabilities = ins.liabilities // 责任
          let liabilitiesLen = liabilities && liabilities.length

          let disease // 险种-所有责任的病重
          let instypeDisease = {}
          // let insDisease = []
          // if (!liabilitiesLen) {

          //   continue
          // }
          for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
            let liab = liabilities[lidx] // 责任
            let liabType = liab.categoryId // 责任类别
            let liabTypeName = liab.categoryName || insTypeName[liabType - 1] // 责任类别名
            let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序

            if (liabOrder < 0) continue
            // // 病种
            // if (liab.disease && liab.disease.title) {
            //   disease = {
            //     pidx, // 产品index
            //     idx,  // 险种
            //     lidx  // 责任
            //   }

            //   if (Array.isArray(instypeDisease[liabOrder])) {
            //     instypeDisease[liabOrder].push(disease)
            //   } else {
            //     instypeDisease[liabOrder] = [disease]
            //   }

            //   if (Array.isArray(insDisease[pidx])) {
            //     insDisease[pidx].push(disease)
            //   } else {
            //      insDisease[pidx] = [disease]
            //   }

            //   // 病种集合
            //   diseasesPath.push(disease)
            // }

            // 同责任类型的
            if (Array.isArray(arrangeInInsType[liabOrder])) {
              let matchingInsType = arrangeInInsType[liabOrder]
              let matchLen = matchingInsType.length - 1 || 0
              let exItem = matchingInsType[matchLen]

              let itDisease = instypeDisease[liabOrder]

              if (
                exItem.insuranceId === insId &&
                exItem.liabilities &&
                exItem.liabilities.length
              ) {
                // 全部病种路径存储在第一条责任
                // disease && exItem.disease.push(disease)
                exItem.liabilities.push(liab)
                // 前责任无病种，后有病种需赋值
                // if (!exItem.disease && disease) {
                //   exItem.disease = disease
                //   exItem.itDisease = itDisease
                // }
              } else {
                arrangeInInsType[liabOrder].push({
                  productId,
                  insuranceId: insId,
                  insuranceName: insName,
                  liabilities: [liab],
                  disease, //: [disease]
                  itDisease,
                  liabTypeName,
                })
              }
            } else {
              arrangeInInsType[liabOrder] = [
                {
                  productId,
                  insuranceId: insId,
                  insuranceName: insName,
                  liabilities: [liab],
                  disease, //: [disease]
                  itDisease: instypeDisease[liabOrder],
                  liabTypeName,
                },
              ]
            }
          }

          // let arrangeMap = {
          //   productId,
          //   disease,
          //   insDisease,
          //   ins
          // }

          // if (accountMap[productId] && accountMap[productId][insId]) {

          //   let liabType = insTypeName.indexOf(ZJLQ_TYPE) + 1
          //   let liabOrder = insTypeOrder.indexOf(liabType)

          //   let insAccountMap = accountMap[productId][insId]

          //   let accountIndex = getAccountLiabIndex(arrangeInInsType[liabOrder], {productId, insId})

          //   // [万能账户]已存在，且追加领取
          //   // 1. 责任-追加领取
          //   if (accountIndex > -1) {
          //     arrangeInInsType[liabOrder][accountIndex].accountMap = insAccountMap
          //   } else {
          //     let arrangeTypeMap = {
          //       productId,
          //       insuranceId: insId,
          //       insuranceName: insName,
          //       // liabilities: [liab],
          //       liabTypeName: ZJLQ_TYPE,
          //       accountMap: insAccountMap,
          //     }
          //     if (Array.isArray(arrangeInInsType[liabOrder])) {
          //       arrangeInInsType[liabOrder].push(arrangeTypeMap)
          //     } else {
          //       arrangeInInsType[liabOrder] = [arrangeTypeMap]
          //     }
          //   }
          //   // 2. 险种-追加领取
          //   arrangeMap.accountMap = insAccountMap
          //   // console.log(['1', accountMap[productId], accountMap[productId][insId]]);
          // }
          // arrangeProduct.push(arrangeMap)
        }

        if (accInsuranceLen) {
          for (let accIndex = 0; accIndex < accInsuranceLen; accIndex++) {
            let ins = accInsurance[accIndex] // 险种

            let accMap = {
              productId,
              // disease,
              ins,
            }
            accProduct.push(accMap)
          }
        }
        // arrangeInIns.push(arrangeProduct)
        accProduct.length && accidentInIns.push(accProduct)
      }

      return arrangeInInsType
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getInsuranceType(liabilities) {
      const result = {}
      if (!Array.isArray(liabilities)) return result
      liabilities.forEach((lib) => {
        const categoryId = lib.categoryId
        const categoryName = lib.categoryName
        if (result[categoryId]) return
        result[categoryId] = categoryName
      })
      return result
    },
    format(prodId, template, data) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this.formatFnCenter `' + template + '`;'
      )
      return formatASCII(g.apply(self, dataList))
    },
    formatFnCenter(templateData) {
      var resultTemp = templateData[0]
      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])
        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(formatTenThousand(arg))
        } else if (arg.match(/元/)) {
          // 针对三元运算符内整万显示
          const re = /(\d+\.\d+|\d+)元/g
          const matchMoney = arg.match(re)
          if (matchMoney) {
            if (matchMoney.length > 1 && matchMoney[1]) {
              arg = arg.replace(re, function () {
                // arguments 对应各个匹配的字符
                return String(
                  formatTenThousand(arguments[0].match(/(\d+\.\d+|\d+)元/)[1])
                )
              })
            } else {
              const matchNum = matchMoney[0] || matchMoney
              arg = arg.replace(re, function () {
                return String(
                  formatTenThousand(matchNum.match(/(\d+\.\d+|\d+)元/)[1])
                )
              })
            }
          }
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    },
    productNameShowList(list, index) {
      const {
        pbResultData: { productNameList },
      } = this
      const SHOW_PRODUCT_NAME = [1, 3, 6, 8]
      if (!Array.isArray(list)) return
      const product = list[0]
      const categoryId = product.liabilities[0].categoryId
      if (SHOW_PRODUCT_NAME.indexOf(categoryId) < 0) return

      let productName
      let productIndex = []
      let count = 0

      list.forEach((item) => {
        const pdName = productNameList[item.productId]
        if (productName && productName == pdName) {
          productIndex.push('')
        } else {
          productIndex.push(pdName)
          count++
          productName = pdName
        }
      })

      return count >= 2 ? productIndex[index] : null
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="showType === 0"
      class="pc-table-wrap pb-responsibility-table-wrap"
    >
      <table class="pc-table pb-responsibility-table">
        <thead>
          <tr>
            <!-- <th>被保人</th> -->
            <th>保障计划</th>
            <th>险种</th>
            <th>保障概要</th>
            <th>保障责任</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(product, pi) in pbResultData.liabilities">
            <template v-for="(insurance, i) in product.insuranceLiabilities">
              <tr>
                <template v-if="i === 0">
                  <td :rowspan="product.insuranceLiabilities.length">
                    {{
                      pbResultData.resultData.productGroupList[0].prodOrderList[
                        pi
                      ].titleName
                    }}
                  </td>
                </template>
                <td>{{ insurance.insuranceName }}</td>
                <td>
                  <p v-for="t in getInsuranceType(insurance.liabilities)">
                    {{ t }}
                  </p>
                </td>
                <!-- <template v-if="i === 0">
                  <td :rowspan="product.insuranceLiabilities.length">
                    <p v-for="t in getInsuranceType(product.insuranceLiabilities)">{{ t }}</p>
                  </td>
                </template> -->
                <td>
                  <div class="ins">
                    <div v-for="lb in insurance.liabilities">
                      <div
                        v-if="lb.description1"
                        class="description1"
                        v-html="
                          format(
                            product.productId,
                            lb.description1,
                            pbResultData.calData
                          )
                        "
                      />
                      <div
                        v-if="lb.description2"
                        class="description2"
                        v-html="
                          format(
                            product.productId,
                            lb.description2,
                            pbResultData.calData
                          )
                        "
                      />
                      <div
                        v-if="showComplete"
                        class="comment"
                        v-html="
                          format(
                            product.productId,
                            lb.comment,
                            pbResultData.calData
                          )
                        "
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <div v-if="showType === 1" class="pc-table-wrap pb-instype-table-wrap">
      <table class="pc-table pb-instype-table">
        <thead>
          <tr>
            <!-- <th>被保人</th> -->
            <!-- <th>保障计划</th> -->
            <!-- <th>险种</th> -->
            <th>保障概要</th>
            <!-- <th>保障计划</th> -->
            <th>保障责任</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in arrangeInInsType"
            v-if="item"
            :key="index"
          >
            <td>{{ item[0] ? item[0].liabTypeName : '' }}</td>
            <td>
              <template v-for="(product, pidx) in item">
                <h4 v-if="productNameShowList(item, pidx)" class="product-name">
                  {{ productNameShowList(item, pidx) }}
                </h4>
                <div class="ins-box">
                  <!-- <div class="ins-name">{{ product.insuranceName }}</div> -->
                  <div class="ins-bd">
                    <template v-for="(lb, idx) in product.liabilities">
                      <div v-if="lb.headline" class="headline">
                        {{ lb.headline }}
                      </div>
                      <div
                        v-if="lb.description1"
                        class="description1"
                        v-html="
                          format(
                            product.productId,
                            lb.description1,
                            pbResultData.calData
                          )
                        "
                      />
                      <div
                        v-if="lb.description2"
                        class="description2"
                        v-html="
                          format(
                            product.productId,
                            lb.description2,
                            pbResultData.calData
                          )
                        "
                      />
                      <div
                        v-if="showComplete && lb.comment"
                        class="comment"
                        v-html="
                          format(
                            product.productId,
                            lb.comment,
                            pbResultData.calData
                          )
                        "
                      />
                    </template>
                  </div>
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style>
@import 'variable.css';

.pb-responsibility-table,
.pb-instype-table {
  .headline {
    font-size: 17px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: bold;
  }

  .description1 {
    position: relative;
    margin-bottom: 5px;
    margin-top: 4px;
    line-height: 21px;
    font-size: 15px;
    text-align: justify;
    span {
      position: relative;
      top: 1px;
      font-size: 18px;
      font-weight: 500;
      margin: 0 3px;
      line-height: 1;
      color: #ed9e14;
    }
    &:before {
      content: '';
      position: absolute;
      left: -10px;
      top: 8px;
      border: 3px solid #ed9e14;
      border-radius: 50%;
      vertical-align: middle;
    }
  }

  .description2 {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;
    color: var(--patch-color-text);
  }

  .waitingDuration,
  .comment {
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 20px;
    color: var(--patch-color-text);
  }

  .comment {
    /*display: none;*/
    margin-top: -2px;
    text-align: justify;
  }

  .ins {
    padding-left: 25px;
  }
}

.pb-responsibility-table {
  th {
    &:nth-child(1) {
      width: 12%;
    }
    &:nth-child(2) {
      width: 15%;
    }
    &:nth-child(3) {
      width: 10%;
    }
  }
}

.pb-instype-table {
  th {
    &:nth-child(1) {
      width: 12%;
    }
  }
  tbody {
    td {
      &:nth-child(3) {
        text-align: center;
      }
    }
  }
  .product-name {
    margin: 15px 0 10px;
    padding: 0 20px 0 0;
    font-size: 15px;
    color: #999;
  }
}
</style>